const ProtocalType_C2S = {};
ProtocalType_C2S.MC = "MC";// 聊天消息包(顾客发给客服)
ProtocalType_C2S.ACK = "ACK";// ack应答包
ProtocalType_C2S.MBR = "MBR";// 客服-顾客消息被已读
ProtocalType_C2S.MBRA = "MBRA";// 客服-顾客消息所有消息被已读

export default ProtocalType_C2S;
